<template>
  <div>
    <list ref="list" :url="url" :autoGetData="false" :limit="limit" @page-load="onListLoad">
      <template v-slot="{ list }">
        <div class="course-certs">
          <div class="course-cert" v-for="(item, index) in list" :key="index">
            <div class="course-cert_left">
              <img class="course-cert_img" src="@/assets/images/cert/cover@2x.png" />
              <img
                v-if="!item.status && !isMember"
                class="course-cert_tag"
                src="@/assets/images/cert/wait@2x.png"
              />
              <img
                v-else-if="item.status == 2"
                class="course-cert_tag"
                src="@/assets/images/cert/recall@2x.png"
              />
            </div>
            <div class="course-cert_middle">
              <div class="course-cert_title">{{ item.name }}</div>
              <div class="course-cert_info">证书编号：{{ item.number || '-' }}</div>
              <div class="course-cert_info">
                <span>获取时间：</span>
                <span v-if="!item.created_at">-</span>
                <span v-else>{{ item.created_at | tsFormatLong }}</span>
              </div>
            </div>
            <div class="course-cert_right">
              <div class="course-cert_btn" @click="onRecall(item)" v-if="item.status == 2">
                撤回原因
              </div>
              <template v-if="isMember">
                <div v-if="item.status == 1" class="course-cert_btn" @click="onDownload(item)">
                  下载证书
                </div>
              </template>
              <div
                v-if="!isMember || !item.status"
                class="course-cert_btn"
                @click="onCondition(item)"
              >
                获取条件
              </div>
              <div
                v-if="item.status == 1"
                class="course-cert_btn course-cert_btn-theme"
                @click="onView(item)"
              >
                查看证书
              </div>
            </div>
          </div>
        </div>
        <EmptyNew v-if="list.length == 0" title="暂无数据"></EmptyNew>
      </template>
    </list>
    <Dialog title="撤回原因" v-model="showRecallDialog" width="560px">
      <template v-if="currentItem">
        <div class="course-cert-recall">
          <span class="course-cert-recall_label">证书名称：</span>
          <span class="course-cert-recall_value">{{ currentItem.name }}</span>
        </div>
        <div class="course-cert-recall">
          <span class="course-cert-recall_label">撤回原因：</span>
          <span class="course-cert-recall_value">
            {{ currentItem.reason || (currentItem.withdraw && currentItem.withdraw.reason) }}
          </span>
        </div>
        <div class="course-cert-recall">
          <span class="course-cert-recall_label">撤回时间：</span>
          <span class="course-cert-recall_value">
            <template v-if="currentItem.withdraw_time">
              {{ currentItem.withdraw_time | tsFormatLong }}
            </template>
            <template v-else-if="currentItem.withdraw">
              {{ currentItem.withdraw.withdraw_time | tsFormatLong }}
            </template>
          </span>
        </div>
      </template>
    </Dialog>
    <Dialog title="获取条件" v-model="showConditionDialog" width="560px">
      <div class="course-cert-condition">
        <div class="course-cert-condition_title">证书名称</div>
        <div v-if="currentItem">{{ currentItem.name }}</div>
      </div>
      <div v-if="requiredList.length > 0" class="course-cert-condition">
        <div class="course-cert-condition_title">必修课程</div>
        <div>
          <div
            class="course-cert-condition_course"
            :class="{
              'course-cert-condition_course_cert_get': course.is_finish != 0,
            }"
            v-for="(course, index) in requiredList"
            :key="index"
          >
            <a class="course-cert-condition_name" @click="onCourseClick(course)">
              《{{ course.course_name }}》
            </a>
            <span>每个课时学习进度</span>
            <span class="course-cert-condition_progress"> {{ course.progress }}% </span>
            <span>以上；</span>
          </div>
        </div>
      </div>
      <div v-if="requiredExam.length > 0" class="course-cert-condition">
        <div class="course-cert-condition_title">必修考试</div>
        <div>
          <div
            class="course-cert-condition_course"
            :class="{
              'course-cert-condition_course_cert_get': exam.is_finish != 0,
            }"
            v-for="(exam, index) in requiredExam"
            :key="index"
          >
            <a class="course-cert-condition_name">《{{ exam.name }}》</a>
            <span>
              {{ exam.gain_style == 1 ? '考试通过' : '考试交卷成功' }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="electiveList.length > 0" class="course-cert-condition">
        <div class="course-cert-condition_title">
          <span>选修课程</span>
          <span class="course-cert-condition_option">
            <span>至少完成</span>
            <span class="color" v-if="currentItem">
              {{ currentItem.option_num }}
            </span>
            <span>个课程</span>
          </span>
        </div>
        <div>
          <div
            class="course-cert-condition_course"
            :class="{
              'course-cert-condition_course_cert_get': course.is_finish != 0,
            }"
            v-for="(course, index) in electiveList"
            :key="index"
          >
            <a class="course-cert-condition_name" @click="onCourseClick(course)">
              《{{ course.course_name }}》
            </a>
            <span>每个课时学习进度</span>
            <span class="course-cert-condition_progress"> {{ course.progress }}% </span>
            <span>以上；</span>
          </div>
        </div>
      </div>
      <div v-if="electiveExam.length > 0" class="course-cert-condition">
        <div class="course-cert-condition_title">
          <span>选修考试</span>
          <span class="course-cert-condition_option">
            <span>至少完成</span>
            <span class="color" v-if="currentItem">
              {{ currentItem.exam_num }}
            </span>
            <span>场考试</span>
          </span>
        </div>
        <div>
          <div
            class="course-cert-condition_course"
            :class="{
              'course-cert-condition_course_cert_get': exam.is_finish != 0,
            }"
            v-for="(exam, index) in electiveExam"
            :key="index"
          >
            <a class="course-cert-condition_name">《{{ exam.name }}》</a>
            <span>
              {{ exam.gain_style == 1 ? '考试通过' : '考试交卷成功' }}
            </span>
          </div>
        </div>
      </div>
    </Dialog>
    <Download ref="download"></Download>
    <el-dialog :visible.sync="showCertViewModal" class="course-cert-view">
      <img class="course-cert-view_img" :src="certUrl" />
      <img
        class="course-cert-view_close"
        src="@/assets/images/cert/close@2x.png"
        @click="showCertViewModal = false"
      />
    </el-dialog>
  </div>
</template>
<script>
import Dialog from '@/components/Dialog.vue';
import Download from '@/components/Download.vue';
import EmptyNew from '@/components/EmptyNew.vue';

export default {
  name: 'CourseCert',
  components: { Dialog, Download, EmptyNew },
  props: {
    url: {
      type: String,
    },
    isMember: {
      type: Boolean,
      default: false,
    },
    hasPage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showRecallDialog: false,
      showConditionDialog: false,
      certUrl: '',
      showCertViewModal: false,
      currentItem: null,
    };
  },
  computed: {
    requiredList() {
      if (!this.currentItem || !this.currentItem.course_info) {
        return [];
      }
      return this.currentItem.course_info.filter((t) => t.type == 1);
    },
    electiveList() {
      if (!this.currentItem || !this.currentItem.course_info) {
        return [];
      }
      return this.currentItem.course_info.filter((t) => t.type == 2);
    },
    limit() {
      return this.hasPage ? 10 : 999999;
    },
    requiredExam() {
      if (!this.currentItem || !this.currentItem.exam_info) {
        return [];
      }
      return this.currentItem.exam_info.filter((t) => t.type == 1);
    },
    electiveExam() {
      if (!this.currentItem || !this.currentItem.exam_info) {
        return [];
      }
      return this.currentItem.exam_info.filter((t) => t.type == 2);
    },
  },
  methods: {
    onListLoad() {
      this.$emit('load');
    },
    onRecall(item) {
      this.showRecallDialog = true;
      this.currentItem = item;
    },
    onCondition(item) {
      this.showConditionDialog = true;
      this.currentItem = item;
    },
    searchRefresh() {
      this.$refs.list.searchRefresh();
    },
    onDownload(item) {
      this.$refs.download.beginDownload(item.url, item.name + '.jpg');
    },
    onView(item) {
      this.certUrl = '';
      this.certUrl = item.url;
      this.showCertViewModal = true;
    },
    onCourseClick(course) {
      this.showConditionDialog = false;
      this.$router.push({
        name: 'CourseShow',
        params: { id: course.course_id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.course-certs {
  padding: 8px 24px 33px 30px;
}

.course-cert {
  display: flex;
  position: relative;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 16px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.course-cert_left {
  margin-right: 16px;
}

.course-cert_img {
  width: 180px;
  height: 134px;
  display: block;
}

.course-cert_tag {
  width: 64px;
  height: 26px;
  position: absolute;
  left: 0;
  top: -4px;
}

.course-cert_middle {
  flex: 1;
}

.course-cert_title {
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 12px;
}

.course-cert_info {
  color: #999999;
  line-height: 20px;
  margin-bottom: 6px;
}

.course-cert_btn {
  width: 96px;
  height: 36px;
  box-sizing: border-box;
  opacity: 1;
  border: 1px solid #bfbfbf;
  border-radius: 21px;
  text-align: center;
  line-height: 34px;
  display: inline-block;
  margin-left: 12px;
  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }
}

.course-cert_btn-theme {
  color: $primary-color;
  border-color: $primary-color;
}

.course-cert-recall {
  display: flex;
  line-height: 22px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.course-cert-recall_label {
  color: #999999;
  flex-shrink: 0;
}

.course-cert-condition {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.course-cert-condition_title {
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  position: relative;
  padding-left: 9px;
  margin-bottom: 6px;

  &::before {
    content: '';
    position: absolute;
    width: 3px;
    height: 15px;
    background: #ffbc33;
    border-radius: 2px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.course-cert-condition_option {
  font-weight: 400;
  font-family: PingFangSC, PingFangSC-Regular;
  color: #333333;
  margin-left: 7px;
}

.course-cert-condition_name {
  color: $primary-color;
  cursor: pointer;

  &:visited {
    color: $primary-color;
  }
}

.course-cert-condition_progress {
  margin: 0 2px;
  color: #c07a14;
}

.course-cert-condition_course {
  margin-bottom: 10px;
  color: #999999;
  &:last-child {
    margin-bottom: 0;
  }
}

.course-cert-condition_course_cert_get {
  padding-right: 25px;
  background: url('~@/assets/images/cert/ic-cert-get.png') no-repeat top right;
  background-size: 20px 20px;
}

.course-cert-view {
  ::v-deep {
    .el-dialog {
      width: auto;
      text-align: center;
      background: transparent;
      box-shadow: none;
      margin-top: 10vh !important;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      max-height: calc(100vh - 2px);
    }
  }
  .course-cert-view_img {
    max-width: 700px;
    max-height: 620px;
  }
  .course-cert-view_close {
    position: absolute;
    width: 28px;
    margin-left: 12px;
    margin-top: -44px;
    cursor: pointer;
  }
}
</style>
